<template>
  <EditItemForm :con="con" :editedItem="editedItem" @closed="close">
    <template v-slot:dialog-text="{ item }">
      <v-container>
        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="item.name"
              :label="$t('crudDesks.fieldName')"
              :rules="rules.inputTextRequired"
              required
              color="grey"
            />
          </v-col>          
          <v-col cols="4">
            <v-select
              v-model="item.deskType"
              :items="$enumDeskType"
              :label="$t('crudDesks.deskType')"
              color="grey"
            />
          </v-col>
          <v-col cols="4">
            <v-switch
              v-model="item.available"
              :label="$t('crudDesks.fieldAvailable')"
              color="red"
            />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </EditItemForm>
</template>

<script>
import EditItemForm from "../EditItemForm";
import rules from "@/models/InputRules";

export default {
  name: "EditDeskForm",
  components: {
    EditItemForm,
  },
  props: {
    con: null,
    editedItem: null,
  },
  computed: {},
  data: () => ({
    rules: rules,
  }),
  methods: {
    close() {
      this.$emit("closed");
    },
  },
};
</script>
